import get from 'lodash/get';

export const Oked = (item) => ({
  id: get(item, 'id') || '',
  name: {
    uz: get(item, 'name.uz') || '',
    oz: get(item, 'name.oz') || '',
    ru: get(item, 'name.ru') || '',
    en: get(item, 'name.en') || ''
  },
  requirements_count: get(item, 'requirements_count') || 0,
  code: get(item, 'code') || ''
});

export const Meta = (item) => ({
  totalPages: get(item, 'total_pages') || 0,
  totalItems: get(item, 'total_count') || 0,
  current: get(item, 'page') ? get(item, 'page') + 1 : 1,
  perPage: get(item, 'size') || 1
});
